import Instructions from "./Instructions"

export default Instructions;